// Material Icons (Apache-2.0), generated from @mui/icons-material ArrowForward — do not edit by hand.
import { createSvgIcon } from '../SvgIcon';

export default createSvgIcon(<path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />, 'ArrowForward');
